module.exports = __webpack_public_path__ + "static/media/botones-03.999bbdc4.png";